import { useEffect, useState } from "react";
import { Route } from "../../types/api";
import { listRoutes } from "../../api/route";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Box, Button, Paper, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function RouteListPage() {
    const navigate = useNavigate()
    const role = (localStorage.getItem("role") || "").toLowerCase()
    const isInspector = role === "inspector"

    const [routes, setRoutes] = useState<Route[]>([])

    const load = async () => {
        const data = await listRoutes()
        setRoutes(data)
    }

    useEffect(() => {
        load()
    }, [])

    const columns: GridColDef[] = [
        { field: "id", width: 80 },
        { field: 'name', headerName: 'ชื่อ', flex: 1 },
        {
            field: 'actions',
            headerName: 'การจัดการ',
            sortable: false,
            filterable: false,
            width: 180,
            renderCell: (params) => (
                !isInspector && ( // 👈 Inspector จะไม่เห็น action buttons เลย
                    <Box display="flex" gap={1}>
                        <Button
                            size="small"
                            variant="contained"
                            onClick={() => navigate(`/routes/edit/${params.row.id}`)}
                            startIcon={<Edit />}
                            color="warning"
                        >
                            แก้ไข
                        </Button>

                    </Box>
                )
            ),
        },
    ]

    return (
        <Box>
            <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
                <Typography variant="h2" > รายการเส้นทาง </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate('/routes/create')}
                >
                    สร้างเส้นทาง
                </Button>
            </Box>
            <Paper sx={{ height: 500, width: '100%', p: 1 }}>
                <DataGrid
                    rows={routes}
                    columns={columns}
                    pageSizeOptions={[5, 10, 20]}
                    initialState={{
                        pagination: { paginationModel: { pageSize: 10 } },
                    }}
                    disableRowSelectionOnClick
                    getRowId={(row) => row.id}
                    sx={{
                        border: 0,
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: '#FEDC00',
                            color: '#000',
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-row': {
                            backgroundColor: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#FFFDE7', // แถวคี่
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#FFF59D', // hover
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #eee',
                        },
                    }}
                />
            </Paper>
        </Box>
    )
}